import { Component, OnInit } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { map } from "rxjs/operators";
import { debounceTime } from 'rxjs/operators';
import { SiteDto } from '../../../dtos/siteDto';
import { GlobalDataService } from '../../../shared-services/global-data.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { OperatorFunction } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { Options } from '@angular-slider/ngx-slider';
import { ApiConfigService } from '../../../shared-services/api-config.service';
import { FilterService } from '../../virtualTour/services/filter.service';
import { CulturalRouteService } from '../../virtualTour/services/cultural-route.service';
import * as _ from 'lodash';
import { CulturalRouteVo } from '../../../vo/culturalRouteVo';
import * as moment from 'moment-timezone';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CulturalRouteAvailability } from '../../../dtos/culturalRouteAvailability';
import { AttributeValuesDto } from '../../../dtos/attributeValuesDto';
import { tap } from 'rxjs/operators';
import { SitesDataService } from '../data-storage/sites-data.service';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';

const statesWithFlags: { name: string, country: string, region: string, state: string }[] = [
    {'name': 'Ancient Corinth', 'country': 'Greece', 'region': 'Peloponnese', 'state': 'Corinth'}
];

@Component({
    selector: 'app-search-results',
    templateUrl: './search-results.component.html',
    styleUrls: ['./search-results.component.scss']
})
export class SearchResultsComponent implements OnInit, AfterViewInit {

    @ViewChild('content')
    modalContent: any;

    modalAvailabilities: CulturalRouteAvailability[];
    selectedAvailability: CulturalRouteAvailability;

    constructor(public globalDataService: GlobalDataService,
                private router: Router,
                private route: ActivatedRoute,
                private apiConfigService: ApiConfigService,
                private filterService: FilterService,
                private culturalRouteService: CulturalRouteService,
                private modalService: NgbModal,
                private sitesDataService: SitesDataService,
                private calendar: NgbCalendar, public formatter: NgbDateParserFormatter) {
    }

    videoPlay: boolean;
    activeSite: SiteDto;
    flowLoading: boolean = true;
    model: any;

    lowValue: number = 23;
    highValue: number = 70;

    lowDuration: number = 0;
    highDuration: number = 120;

    options: Options = {
        floor: 0,
        ceil: 200
    };
    urlParams: any;
    extraFilters: any;
    filteredResults: CulturalRouteVo[] = [];
    $sites: Observable<SiteDto[]>;
    $cities: Observable<any>;
    selectedCities: any[] = [];

    fromDate: NgbDate | null;
    toDate: NgbDate | null;
    hoveredDate: NgbDate | null = null;


    private queryFilters: any = {};
    search: OperatorFunction<string, readonly { name: string, country: string, region: string, state: string }[]> = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            map(term => term === '' ? []
                : statesWithFlags.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
        )

    ngOnInit(): void {
        // this.startChatPort();
        //this.fromDate = this.calendar.getToday();
        //this.toDate = this.calendar.getNext(this.calendar.getToday(), 'd', 10);
        this.$sites = this.sitesDataService.sites;
        this.$cities = this.culturalRouteService.getCities().pipe(
            map(this.filterService.cityByGroup.bind(this)),
            tap((cities) => {
                const selectedOnes = this.queryFilters['cities'] ? this.queryFilters['cities'].split(",").map(Number.bind(this)) : [];
                this.selectedCities = cities.filter((city) => {
                    return selectedOnes.includes(city.id);
                })
            })
        );
    }

    ngAfterViewInit(): void {
        this.route.queryParams
            .pipe(
                tap(() => {
                    this.flowLoading = true;
                })
            )
            .subscribe(params => {
                    this.queryFilters = _.cloneDeep(params);
                    this.lowValue = this.queryFilters['min_price'] ? this.queryFilters['min_price'] : this.options.floor;
                    this.highValue = this.queryFilters['max_price'] ? this.queryFilters['max_price'] : this.options.ceil;
                    this.lowDuration = this.queryFilters['duration_min'] ? this.queryFilters['duration_min'] : this.options.floor;
                    this.highDuration = this.queryFilters['duration_max'] ? this.queryFilters['duration_max'] : this.options.ceil;
                    if (this.queryFilters['date_min'] && this.queryFilters['date_max']) {
                        const fromDateMoment = moment(this.queryFilters['date_min']).tz('Europe/Athens');
                        const toDateMoment = moment(this.queryFilters['date_max']).tz('Europe/Athens');
                        this.fromDate = new NgbDate(fromDateMoment.year(), (fromDateMoment.month() + 1), fromDateMoment.date())
                        this.toDate = new NgbDate(toDateMoment.year(), (toDateMoment.month() + 1), toDateMoment.date())
                    }

                    this.culturalRouteService.getAttributes()
                        .subscribe((attributes: AttributeValuesDto[]) => {
                            this.extraFilters = this.filterService.getSearchFilters(attributes);
                        })
                    this.culturalRouteService.getCulturalRoutes(params)
                        .subscribe((results) => {
                            this.filteredResults = results;
                            this.flowLoading = false;
                        })
                }
            );
    }

    isAvailable(date, availabilities) {
        const currentDate = date.year + '-' + date.month + '-' + date.day;
        return availabilities.filter((date) => {
            const countDownDate = moment(date.dateTimeStart).tz('Europe/Athens');
            const dateString = countDownDate.year() + '-' + (countDownDate.month() + 1) + '-' + countDownDate.date();
            return dateString === currentDate;
        }).length > 0;
    }

    getTime(date: string) {
        return moment(date).tz('Europe/Athens').format("HH:mm");
    }

    openDayPopup(date, availabilities) {
        if (this.isAvailable(date, availabilities)) {
            const modalRef = this.modalService.open(this.modalContent, {centered: true, size: 'lg'});
            this.modalAvailabilities = availabilities;
        } else {
            return false;
        }
    }

    filterChange(value: AttributeValuesDto) {
        if (this.queryFilters[value.attribute.code.toLowerCase()]) {
            const values = this.queryFilters[value.attribute.code.toLowerCase()].split(",");
            if (!values.includes(value.value)) {
                values.push(value.value);
            } else {
                const indexOf = values.findIndex((existingValue) => existingValue === value.value);
                values.splice(indexOf, 1);
            }
            this.queryFilters[value.attribute.code.toLowerCase()] = values.join(",");
        } else {
            this.queryFilters[value.attribute.code.toLowerCase()] = value.value;
        }

        this.router.navigate(
            ['remote/' + this.globalDataService.getCurrentLang() + '/results'],
            {queryParams: this.queryFilters}
        );
    }

    durationFilter(event) {
        this.queryFilters['duration_min'] = event.value;
        this.queryFilters['duration_max'] = event.highValue;
        this.router.navigate(
            ['remote/' + this.globalDataService.getCurrentLang() + '/results'],
            {queryParams: this.queryFilters}
        );
    }

    priceFilter(event) {
        this.queryFilters['min_price'] = event.value;
        this.queryFilters['max_price'] = event.highValue;
        this.router.navigate(
            ['remote/' + this.globalDataService.getCurrentLang() + '/results'],
            {queryParams: this.queryFilters}
        );
    }

    siteFilter(siteId) {
        let sitesIds = this.queryFilters['site_ids'] ? this.queryFilters['site_ids'].split(',') : [];
        if (!sitesIds.includes(siteId)) {
            sitesIds.push(siteId);
        } else {
            const indexOf = sitesIds.findIndex((existingValue) => existingValue === siteId);
            sitesIds.splice(indexOf, 1);
        }
        this.queryFilters['site_ids'] = sitesIds.join(',');
        this.router.navigate(
            ['remote/' + this.globalDataService.getCurrentLang() + '/results'],
            {queryParams: this.queryFilters}
        );
    }

    regionFilter() {
        if (this.selectedCities.length > 0) {
            this.queryFilters['cities'] = this.selectedCities.map((city) => city.id).join(",");
            this.router.navigate(
                ['remote/' + this.globalDataService.getCurrentLang() + '/results'],
                {queryParams: this.queryFilters}
            );
        }
    }

    checkedFilter(value) {
        if (this.queryFilters[value.attribute.code.toLowerCase()]) {
            const values = this.queryFilters[value.attribute.code.toLowerCase()].split(",");
            return values.includes(value.value);
        } else {
            return false;
        }
    }

    checkedSite(id) {
        if (this.queryFilters['site_ids']) {
            const values = this.queryFilters['site_ids'].split(",");
            return values.includes(id.toString());
        } else {
            return false;
        }
    }

    onDateSelection(date: NgbDate) {
        if (!this.fromDate && !this.toDate) {
            this.fromDate = date;
        } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
            this.toDate = date;
        } else {
            this.toDate = null;
            this.fromDate = date;
        }
        this.queryFilters['date_min'] = this.formatter.format(this.fromDate);
        this.queryFilters['date_max'] = this.formatter.format(this.toDate);
        if (this.toDate) {
            this.router.navigate(
                ['remote/' + this.globalDataService.getCurrentLang() + '/results'],
                {queryParams: this.queryFilters}
            );
        }

    }

    isHovered(date: NgbDate) {
        return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
    }

    isInside(date: NgbDate) {
        return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
    }

    isRange(date: NgbDate) {
        return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
    }

    validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
        const parsed = this.formatter.parse(input);
        return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
    }

    private startChatPort() {
        (function (w, d, v3) {
            w['chaportConfig'] = {
                appId: '5efdb5fa1b4b08234a76d101'
            };

            if (w['chaport']) return;
            v3 = w['chaport'] = {};
            v3._q = [];
            v3._l = {};
            v3.q = function () {
                v3._q.push(arguments)
            };
            v3.on = function (e, fn) {
                if (!v3._l[e]) v3._l[e] = [];
                v3._l[e].push(fn)
            };
            var s = d.createElement('script');
            s['type'] = 'text/javascript';
            s['async'] = true;
            s['src'] = 'https://app.chaport.com/javascripts/insert.js';
            var ss = d.getElementsByTagName('script')[0];
            ss.parentNode.insertBefore(s, ss)
        })(window, document);
    }
}
